import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ServiceBundler } from './Services/ServiceBundler';
import { AuthProvider, RequireAuth } from './Providers/AuthProvider';
import LoginPage from './Pages/Login/LoginPage';
import HomePage from './Pages/Home/HomePage';
import SoftwareManager from './Components/SoftwareManager/SoftwareManager';
import SoftwareSystem from './Components/SoftwareManager/SoftwarePlatforms/SoftwareSystem';
import ResetPassword from './Pages/ResetPassword/ResetPassword';
import UserDashboard from './Pages/UserDashboard/UserDashboard';
import ProfilePage from './Pages/Profile/ProfilePage';
import Backup from './Pages/Backup/BackupPage';
import ContactPage from './Pages/Contact/ContactPage';
import TranslationsPage from './Pages/Languages/Translations/TranslationsPage';
import LanguagePage from './Pages/Languages/LanguagePage';
import InfoPage from './Pages/Info/InfoPage';
import { ConfigProvider, ThemeConfig, theme } from 'antd';
import { AuthService } from './Services/AuthService';
import { WebSocketService } from './Services/WebSocketService';

export const webSocketService = new WebSocketService();
export const authService = new AuthService();
export const serviceBundler = new ServiceBundler();

export const configThemeLight: ThemeConfig = {
  token: {
    colorPrimary: '#C1D202',
    colorPrimaryText: '#00365f',
    colorPrimaryBg: '#FFFFFF',
  },
};

const configThemeDark: ThemeConfig = {
  token: {
    colorPrimary: '#C1D202',
    colorPrimaryText: '#C1D202',
    colorPrimaryBg: '#141414',
  },
};

export default function App() {
  const [currentTheme, setCurrentTheme] = React.useState<'light' | 'dark'>(
    'light',
  );

  React.useEffect(() => {
    setCurrentTheme(serviceBundler.themeService.IsDarkMode ? 'dark' : 'light');

    serviceBundler.themeService.FetchingReadySubject.subscribe((value) => {
      if (value) {
        setCurrentTheme('dark');
      } else {
        setCurrentTheme('light');
      }
    });
  }, [0]);

  return (
    <ConfigProvider
      theme={{
        token:
          currentTheme === 'light'
            ? configThemeLight.token
            : configThemeDark.token,
        algorithm:
          currentTheme === 'light'
            ? theme.defaultAlgorithm
            : theme.darkAlgorithm,
      }}
    >
      <AuthProvider>
        <Routes>
          <Route>
            <Route path="/" element={<HomePage />} />
            <Route path="*" element={<HomePage />} />
            <Route path="softwaremanager">
              <Route
                index
                element={
                  <RequireAuth>
                    <SoftwareManager />
                  </RequireAuth>
                }
              />
              <Route
                path=":softwareName"
                element={
                  <RequireAuth>
                    <SoftwareSystem />
                  </RequireAuth>
                }
              />
            </Route>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/setpassword/:UniqueToken"
              element={<ResetPassword />}
            />
            <Route
              path="userDashboard"
              element={
                <RequireAuth>
                  <UserDashboard />
                </RequireAuth>
              }
            />
            <Route
              path="profile"
              element={
                <RequireAuth>
                  <ProfilePage />
                </RequireAuth>
              }
            />
            <Route
              path="backup"
              element={
                <RequireAuth>
                  <Backup />
                </RequireAuth>
              }
            />
            <Route path="languages">
              <Route
                index
                element={
                  <RequireAuth>
                    <LanguagePage />
                  </RequireAuth>
                }
              ></Route>

              <Route
                path=":languageKey"
                element={
                  <RequireAuth>
                    <TranslationsPage />
                  </RequireAuth>
                }
              />
            </Route>
            <Route
              path="info"
              element={
                <RequireAuth>
                  <InfoPage />
                </RequireAuth>
              }
            />
            <Route path="overandcontact" element={<ContactPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </ConfigProvider>
  );
}
